import { moduleProviderFactory } from "core/providers";
import {
	ConfirmingReportList,
	ConfirmingReportItemList,
	ConfirmingReportFileUpload,
	ConfirmingReportPumpAndPoleItemList,
	ConfirmingReportSpecificConfirmingStatusItemList
} from "application/confirming-report/pages";

(function () {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: "master.app.main.confirming-report",
				pattern: "/confirming-reports",
				children: [
					{
						name: "master.app.main.confirming-report.list",
						pattern: "",
						tabTitle: "CONFIRMING_REPORT.LIST.TITLE",
						component: ConfirmingReportList,
						authorization: "reportSection.read",
						data: {
							title: "CONFIRMING_REPORT.LIST.TITLE",
						},
					},
					{
						name: "master.app.main.confirming-report.confirming-report-item.list",
						pattern: "/:id/items",
						tabTitle: "CONFIRMING_REPORT_ITEM.LIST.TITLE",
						authorization: "reportSection.read",
						component: ConfirmingReportItemList,
						data: {
							back: "master.app.main.confirming-report.list",
							title: "CONFIRMING_REPORT_ITEM.LIST.TITLE",
							crumbs: {
								title: "CONFIRMING_REPORT_ITEM.CRUMB.CONFIRMING_REPORT_ITEMS",
								route: 'master.app.main.confirming-report.confirming-report-item.list'
							}
						},
					},
					{
						name: "master.app.main.confirming-report.report-upload",
						pattern: "/report-upload",
						tabTitle: "CONFIRMING_REPORT.REPORT_UPLOAD.TITLE",
						authorization: "reportSection.read",
						component: ConfirmingReportFileUpload,
						data: {
							back: "master.app.main.confirming-report.list",
							title: "CONFIRMING_REPORT.REPORT_UPLOAD.TITLE",
							crumbs: {
								title: "CONFIRMING_REPORT_ITEM.CRUMB.UPLOAD",
								route: 'master.app.main.confirming-report.confirming-report-item.list'
							}
						},
					},
					{
						name: "master.app.main.confirming-report.confirming-report-item.pump-and-pole-item.list",
						pattern: "/:id/pump-and-pole-items",
						authorization: "reportSection.read",
						tabTitle: "CONFIRMING_REPORT_ITEM.CRUMB.PUMP_AND_POLES",
						component: ConfirmingReportPumpAndPoleItemList,
						data: {
							back: "master.app.main.confirming-report.confirming-report-item.list",
							title: "CONFIRMING_REPORT_ITEM.PUMP_AND_POLES.TITLE",
							crumbs: {
								title: "CONFIRMING_REPORT_ITEM.CRUMB.PUMP_AND_POLES",
								route: 'master.app.main.confirming-report.confirming-report-item.list'
							}
						},
					},
					{
						name: "master.app.main.confirming-report.confirming-report-item.specific-confirming-status-item.list",
						pattern: "/:id/specific-confirming-status-items",
						authorization: "reportSection.read",
						tabTitle: "CONFIRMING_REPORT_ITEM.CRUMB.CONFIRMING_STATUS",
						component: ConfirmingReportSpecificConfirmingStatusItemList,
						data: {
							back: "master.app.main.confirming-report.confirming-report-item.list",
							title: "CONFIRMING_REPORT_ITEM.CONFIRMING_STATUS.TITLE",
							crumbs: {
								title: "CONFIRMING_REPORT_ITEM.CRUMB.CONFIRMING_STATUS",
								route: 'master.app.main.confirming-report.confirming-report-item.list'
							}
						},
					},
				],
			},
		],
		menu: [
			{
				title: "MENU.REPORTS",
				icon: "table-view",
				order: 9,
				authorization: "reportSection.read",
				subMenu: [
					{
						title: 'MENU.CONFIRMING_REPORTS',
						route: "master.app.main.confirming-report.list",
						order: 1,
					}
				]
			},
		],
	});
})();